import { useQuery } from '@tanstack/react-query';

import { DefectLevelValueIllustrationIcon, Endpoints } from '@/api';
import IconBuckle from '@/icons/needs/buckle/Buckle.svg';
import IconFemaleBuckle from '@/icons/needs/buckle/Female.svg';
import IconMaleBuckle from '@/icons/needs/buckle/Male.svg';
import IconSewingButton from '@/icons/needs/button/SewingButton.svg';
import IconSnapButton from '@/icons/needs/button/SnapButton.svg';
import IconFabricMaterials from '@/icons/needs/fabric-materials/FabricMaterials.svg';
import IconPilling from '@/icons/needs/fabric-materials/Pilling.svg';
import IconWaterRepellency from '@/icons/needs/fabric-materials/WaterRepellency.svg';
import IconHoles from '@/icons/needs/holes/Holes.svg';
import IconHook from '@/icons/needs/hooks/Hook.svg';
import IconMagnet from '@/icons/needs/hooks/Magnet.svg';
import IconVelcro from '@/icons/needs/hooks/Velcro.svg';
import IconBrandLabel from '@/icons/needs/label/BrandLabel.svg';
import IconLabel from '@/icons/needs/label/Label.svg';
import IconSizeLabel from '@/icons/needs/label/SizeLabel.svg';
import IconSlider from '@/icons/needs/slider-zip/Slider.svg';
import IconSliderZip from '@/icons/needs/slider-zip/SliderZip.svg';
import IconZip from '@/icons/needs/slider-zip/Zip.svg';
import IconNotWaterproofSeam from '@/icons/needs/unstitched-seam/NotWaterproofSeam.svg';
import IconUnstitchedSeam from '@/icons/needs/unstitched-seam/UnstitchedSeam.svg';
import IconWaterproofSeam from '@/icons/needs/unstitched-seam/WaterproofSeam.svg';
import IconHolePocket from '@/icons/needs/unstitched-seam-on-yoke/HolePocket.svg';
import { useFetch } from '@/utils/fetch';

export const useDefectLevelValues = ({
  organizationId,
  articleId,
}: {
  organizationId?: string;
  articleId?: string;
}) => {
  const fetch = useFetch<Endpoints['GET /defect-level-values']>();

  return useQuery({
    queryKey: ['defect-level-values', organizationId, articleId],
    queryFn: () => fetch('/defect-level-values', { articleId }),
    enabled: !!organizationId || !!articleId,
  });
};

export const DEFECT_ICONS_BY_ID = {
  'brand-label': <IconBrandLabel />,
  buckle: <IconBuckle />,
  'fabric-materials': <IconFabricMaterials />,
  'female-buckle': <IconFemaleBuckle />,
  'hole-pocket': <IconHolePocket />,
  holes: <IconHoles />,
  hook: <IconHook />,
  label: <IconLabel />,
  magnet: <IconMagnet />,
  'male-buckle': <IconMaleBuckle />,
  'not-waterproof-seam': <IconNotWaterproofSeam />,
  pilling: <IconPilling />,
  'sewing-button': <IconSewingButton />,
  'size-label': <IconSizeLabel />,
  slider: <IconSlider />,
  'slider-zip': <IconSliderZip />,
  'snap-button': <IconSnapButton />,
  'unstitched-seam': <IconUnstitchedSeam />,
  velcro: <IconVelcro />,
  'water-repellency': <IconWaterRepellency />,
  'waterproof-seam': <IconWaterproofSeam />,
  zip: <IconZip />,
} satisfies Record<DefectLevelValueIllustrationIcon, React.ReactNode>;
